import { Component, OnInit, NgZone } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { NotifierService } from './notifier.service';
import { INotifier } from './notifier.interface';
import * as NodeJS from 'ts-node-dev';
declare var $: any;

@Component({
  selector: 'app-notifier',
  templateUrl: './notifier.component.html',
  styleUrls: ['./notifier.component.scss']
})
export class NotifierComponent implements OnInit, HttpInterceptor {
  notifierData: INotifier;
  activeSuccess: boolean;
  activeWarning: boolean;
  activeError: boolean;
  activeInfo: boolean;
  timeout: NodeJS.Timer;
  constructor(private notifierService: NotifierService, private zone: NgZone) {
    this.notifierData = {
      duration: 1000,
      icon: 'fa-check',
      message: 'Something Happen',
      title: 'Holy Guacamole',
      type: 'success'
    };
    this.activeSuccess = false;
    this.activeWarning = false;
    this.activeError = false;
    this.activeInfo = false;
    this.notifierService.systemMessagesNotifierObject$.subscribe(
      changes => {

        this.notifierData = changes;
        this.notifierData.duration = this.notifierData.duration || 5000;
        this.notifierData.icon = this.notifierData.icon || 'fa-flag';
        if (this.timeout) {
          // clearTimeout(this.timeout);
          this.zone.run(() => {
            this.activeSuccess = this.activeError = this.activeWarning = this.activeInfo = false;
          })

        }

        switch (this.notifierData.type) {
          case 'success': {
            this.activeSuccess = true;
            this.activeInfo = false;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.activeSuccess = false;
            }, this.notifierData.duration);
            break;
          }
          case 'warning': {
            this.activeWarning = true;
            this.activeInfo = false;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.activeWarning = false;
            }, this.notifierData.duration);
            break;
          }
          case 'error': {
            this.activeError = true;
            this.activeInfo = false;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.activeError = false;
            }, this.notifierData.duration);
            break;
          }
          case 'info': {
            this.activeInfo = true;
            clearTimeout(this.timeout);
            this.timeout = setTimeout(() => {
              this.activeInfo = false;
            }, this.notifierData.duration);
            break;
          }
        }
      }
    );
  }

  ngOnInit() {
    //$('.alert').alert();
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    console.log('req', req);
    return next.handle(req);
  }
}


// WEBPACK FOOTER //
// ./src/app/system/shared/notifier/notifier.component.ts